import { EventEmitter } from 'events';

const EmitterMixin = {
  _emitter: null,

  statics: {
    staticEmitter: new EventEmitter(),
    on(event, listener) {
      this.staticEmitter.addListener(event, listener);
    },
    removeListener(event, listener) {
      this.staticEmitter.removeListener(event, listener);
    },
  },

  emit() {
    if (this._emitter) {
      this._emitter.emit.apply(this._emitter, arguments);
    }
    const oldArguments = Array.from(arguments);
    oldArguments.splice(1, 0, this);
    const { staticEmitter } = this.constructor;
    staticEmitter.emit.apply(staticEmitter, oldArguments);
  },

  on(event, listener) {
    this.addListener(event, listener);
  },

  addListener(event, listener) {
    if (!this._emitter) {
      this._emitter = new EventEmitter();
    }
    this._emitter.addListener(event, listener);
  },

  removeListener(event, listener) {
    if (this._emitter) {
      this._emitter.removeListener(event, listener);
    }
  },
};

export default EmitterMixin;



// WEBPACK FOOTER //
// ./src/components/mixins/EmitterMixin.js